import OverlaysModule from 'diagram-js/lib/features/overlays';
// import ChangeSupportModule from 'diagram-js/lib/features/change-support';
// import RootElementsModule from 'diagram-js/lib/features/root-elements';

// import DrilldownBreadcrumbs from './DrilldownBreadcrumbs';
// import DrilldownCentering from './DrilldownCentering';
// import SubprocessCompatibility from './SubprocessCompatibility';
import DrilldownOverlayBehavior from './DrilldownOverlayBehavior';

export default {
  __depends__: [ OverlaysModule ],
  __init__: [ 'callActivityDrilldown'],
  // drilldownBreadcrumbs: [ 'type', DrilldownBreadcrumbs ],
  // drilldownCentering: [ 'type', DrilldownCentering ],
  callActivityDrilldown: [ 'type', DrilldownOverlayBehavior ],
  // subprocessCompatibility: [ 'type', SubprocessCompatibility ]
};